import { render, staticRenderFns } from "./ModalRetomarCompraDireta.vue?vue&type=template&id=d5c82754&scoped=true"
import script from "./ModalRetomarCompraDireta.vue?vue&type=script&lang=js"
export * from "./ModalRetomarCompraDireta.vue?vue&type=script&lang=js"
import style0 from "./ModalRetomarCompraDireta.vue?vue&type=style&index=0&id=d5c82754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c82754",
  null
  
)

export default component.exports